<template>
  <div class="divTableCell" v-if="hasText">
    <div class="divTable">
      <div class="divTableBody">
        <div class="divTableRow">
          <div
            class="
              divTableCell
              divTableCellLabel
              text-uppercase
              label-divTableCell
            "
          >
            {{ label }}:
          </div>
          <div
            class="divTableCell divTableCellValue"
            v-bind:style="{ width: minWidth + 'px' }"
          >
            {{ text }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    text: {
      type: [String, Number],
      default: "",
    },
    minWidth: {
      type: String,
      default: "",
    },
  },
  computed: {
    hasText() {
      return (
        this.text != undefined
        && this.text != null
        && `${this.text}`.trim() !== ''
      );
    },
    getStyle() {
      if (this.minWidth === '') {
        return '';
      }
      return `${this.minWidth}px`;
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
